export function googleSearchDelearInfo({ markenStandort }) {
    if (!markenStandort) {
        return null;
    }

    const { anschrift, oeffnungszeiten, standort, host, areaShopSubLocations } = markenStandort;

    if (!anschrift || !standort || !host) {
        return null;
    }

    const mainHostname = host.hostname;

    const mainOrganization = createOrganizationSchema(markenStandort);
    
    if (!mainOrganization) {
        return null;
    }

    const departments = Array.isArray(areaShopSubLocations) && areaShopSubLocations.length > 0
        ? areaShopSubLocations
            .map(subLocation => createOrganizationSchema(subLocation, mainHostname))
            .filter(Boolean)
        : [];

    mainOrganization.department = departments;

    return mainOrganization;
}

function createOrganizationSchema(standortItem, mainHostname = null) {
    if (!standortItem) {
        return null;
    }

    const { anschrift, oeffnungszeiten, standort, host, url: areaShopUrl } = standortItem;

    if (!anschrift || !standort) {
        return null;
    }

    const { firma, strasse, ort, plz, telefon, email } = anschrift;
    
    let organizationUrl;
    if (host && host.hostname) {
        organizationUrl = `https://${host.hostname}`;
    } else if (mainHostname && areaShopUrl) {
        const cleanUrl = areaShopUrl.startsWith('/') ? areaShopUrl : `/${areaShopUrl}`;
        organizationUrl = `https://${mainHostname}${cleanUrl}`;
    } else {
        organizationUrl = null;
    }

    const openingHoursSpecification = parseOpeningHoursForGoogleSearch(oeffnungszeiten) ?? [];
    
    const organization = {
        '@context': 'https://schema.org/',
        '@type': 'Organization',
        name: firma,
        address: {
            '@type': 'PostalAddress',
            streetAddress: strasse,
            addressLocality: ort,
            postalCode: plz,
            addressCountry: 'DE',
        },
        geo: {
            "@type": "GeoCoordinates",
            latitude: standort.coordinates[0],
            longitude: standort.coordinates[1],
        },
        telephone: telefon,
        email: email ?? '',
        openingHoursSpecification
    };

    if (organizationUrl) {
        organization.url = organizationUrl;
    }

    return organization;
}

function parseOpeningHoursForGoogleSearch(openingHoursString) {
    if (!openingHoursString) return [];
    
    let normalizedString = openingHoursString
        .replace(/\s+/g, ' ')
        .replace(/\|/g, '|')
        .replace(/und/g, '|')
        .trim();
    
    const dayRanges = normalizedString.split('|').map(range => range.trim()).filter(Boolean);
    const results = [];
    
    const dayMap = {
        'Mo': 'Monday',
        'Di': 'Tuesday',
        'Mi': 'Wednesday',
        'Do': 'Thursday',
        'Fr': 'Friday',
        'Sa': 'Saturday',
        'So': 'Sunday',
        'Montag': 'Monday',
        'Dienstag': 'Tuesday',
        'Mittwoch': 'Wednesday',
        'Donnerstag': 'Thursday',
        'Freitag': 'Friday',
        'Samstag': 'Saturday',
        'Sonntag': 'Sunday'
    };
    
    for (const range of dayRanges) {
        const match = range.match(/^([A-Za-zäöüß\s–-]+?):\s*(\d{1,2}:\d{2})\s*-\s*(\d{1,2}:\d{2})\s*(?:Uhr)?/i);
        if (!match) continue;
        
        const dayRange = match[1].trim();
        const opens = match[2].trim();
        const closes = match[3].trim();
        
        let dayOfWeek = [];
        
        // Handle "Mo-Fr" or "Montag-Freitag" pattern (Monday to Friday)
        if (dayRange.match(/^Mo\s*[-–]\s*Fr/i) || dayRange.match(/^Montag\s*[-–]\s*Freitag/i)) {
            dayOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
        } 
        else if (dayRange.match(/^Mo\s*[-–]\s*Sa/i) || dayRange.match(/^Montag\s*[-–]\s*Samstag/i)) {
            dayOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        }
        // Handle "Sa" or "Samstag" (Saturday)
        else if (dayRange.match(/^Sa\b/i) || dayRange.match(/^Samstag/i)) {
            dayOfWeek = ['Saturday'];
        }
        // Handle "So" or "Sonntag" (Sunday)
        else if (dayRange.match(/^So\b/i) || dayRange.match(/^Sonntag/i)) {
            dayOfWeek = ['Sunday'];
        }
        // Handle "Sa-So" or "Samstag-Sonntag" (Saturday to Sunday)
        else if (dayRange.match(/^Sa\s*[-–]\s*So/i) || dayRange.match(/^Samstag\s*[-–]\s*Sonntag/i)) {
            dayOfWeek = ['Saturday', 'Sunday'];
        }
        // Handle individual days
        else {
            for (const [abbr, full] of Object.entries(dayMap)) {
                if (dayRange.includes(abbr)) {
                    if (!dayOfWeek.includes(full)) {
                        dayOfWeek.push(full);
                    }
                }
            }
        }
        
        if (dayOfWeek.length > 0) {
            results.push({
                '@type': 'OpeningHoursSpecification',
                dayOfWeek,
                opens,
                closes
            });
        }
    }
    
    return results;
}